import * as RdsDataProductReducer from './data-product.reducer';

export { RdsDataProductReducer };
